import { Badge } from '@artic/ui/badge';
import type { QueryClient } from '@tanstack/react-query';
import type { AnyRouteMatch } from '@tanstack/react-router';
import type { ReactNode } from 'react';

import { OperationLifecycleBadge } from './operation-lifecycle-badge';
import { operationDetailQueryOptions } from './queries';

/**
 * Version + Archived + lifecycle-state badges, rendered after the final
 * breadcrumb on all four operation-detail routes (ENG-624, ENG-813 Card 1).
 * One shared resolver so the trio doesn't have to be repeated per route.
 */
export function operationBreadcrumbBadges(
  match: AnyRouteMatch,
  queryClient: QueryClient,
): ReactNode {
  const { operation_id: operationId } = match.params as { operation_id: string };
  const data = queryClient.getQueryData(operationDetailQueryOptions(operationId).queryKey);
  if (!data) return null;
  return (
    <>
      <Badge variant="outline" className="font-mono text-xs">
        v{data.operation_version}
      </Badge>
      {data.is_archived && <Badge variant="secondary">Archived</Badge>}
      <OperationLifecycleBadge operationId={operationId} />
    </>
  );
}
